/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { Theme } from "@mui/material";

const footerStyle = {
  footerContainer: (theme: Theme) => ({
    padding: "2rem",
    color: "primary.contrastText",
    ...(theme.palette.mode === "dark"
      ? {
          backgroundColor: "primary.dark",
        }
      : {
          backgroundColor: "primary.main",
        }),
  }),
  categoryHeadline: {
    color: "primary.contrastText",
    marginBottom: "2rem",
  },
  footerTransition: (theme: Theme) => ({
    ...(theme.palette.mode === "dark"
      ? {
          display: "none",
        }
      : {
          display: "block",
          margin: "0 auto",
          maxWidth: "1000px",
        }),
  }),
  logo: (theme: Theme) => ({
    maxWidth: "250px",
    maxHeight: "80px",
    margin: { xs: "0 auto 3rem auto", md: "0 3rem 3rem 0" },
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  }),
  footer: {
    marginTop: "4rem",
  },
  trademark: {
    marginTop: "2rem",
  },
  linkListContainer: (theme: Theme) => ({
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  }),
  linkList: (theme: Theme) => ({
    alignItems: "center",
    /*width: "100%",
    flexDirection: "column",*/
    [theme.breakpoints.down("md")]: {
      justifyContent: "space-around",
    },
  }),
  linkListItem: (theme: Theme) => ({
    [theme.breakpoints.down("md")]: {
      marginBottom: "1rem",
    },
  }),
  linkListLogo: (theme: Theme) => ({
    [theme.breakpoints.down("md")]: {
      marginBottom: "2rem",
      width: "100%",
    },
  }),
  copyright: (theme: Theme) => ({
    [theme.breakpoints.down("md")]: {
      marginTop: "2rem",
      textAlign: "center",
      width: "100%",
    },
  }),
  link: {
    color: "text.primary",
    textTransform: "uppercase",
    margin: "0 1rem",
  },
  stars: {
    marginRight: "auto",
    marginLeft: "auto",
  },
  footerNav: {
    width: "100%"
  }
};

export default footerStyle;
